/**
 * Manages property pin infinite scrolling
 * @param tooltipManager
 * @param {function} [fnRefresh] a optional function that's called for refreshing the visibility of the pin
 *                EX: function (iPinId, bVisible) { ... }
 */
define(['jquery'], function ($) {
   "use strict";

   return function (tooltipManager, fnRefresh) {
      var self = this,
         m_tooltipManager = tooltipManager,
         m_fnRefresh = fnRefresh,
         m_pinInViewById,

         initialize = function () {
            self.clear();
         };

      self.clear = function () {
         m_pinInViewById = {};
      };

      /**
       * Set the pins currently inside of the view of the user
       * in the modal window
       * 
       * NOTE: Must operate extremely fast, due to
       * being called numerous times as the user scrolls
       */
      self.setPinsInView = function (aPinId, oPinDataById) {
         var oNewPinsInView = {};
         $.each(aPinId, function (i, iPinId) {
            oNewPinsInView[iPinId] = true;
            if (!m_pinInViewById[iPinId]) {
               m_pinInViewById[iPinId] = true;
               m_fnRefresh(iPinId, true);
            }
         });

         $.each(m_pinInViewById, function (iPinId, b) {
            if (!oNewPinsInView[iPinId]) {
               if (m_tooltipManager.hideTooltipByPinData) {
                  // Since the small pushpins are currently hidden,
                  // it doesn't make any sense to have a tooltip showing
                  // over nothing!
                  var pinData = oPinDataById[iPinId];
                  m_tooltipManager.hideTooltipByPinData(pinData);
               }

               delete m_pinInViewById[iPinId];
               m_fnRefresh(iPinId, false);
            }
         });
      };

      initialize();
   };
});
